import { ReactNode } from 'react'

import PortableLink from '@/app/components/PortableLink'
import { TrackingLocation } from '@/app/utils/analytics'

/**
 * Shared portable text mark components used across PortableText and PortableTextMinimal
 */
export const createPortableTextMarks = (tracking: TrackingLocation) => ({
  link: ({ children, value: link }: { children: ReactNode; value?: unknown }) => {
    return (
      <PortableLink link={link} tracking={tracking}>
        {children}
      </PortableLink>
    )
  },
  mark: ({ children }: { children: ReactNode }) => (
    <mark>
      <span className="relative">{children}</span>
    </mark>
  ),
  uppercase: ({ children }: { children: ReactNode }) => (
    <span className="uppercase">{children}</span>
  ),
  nowrap: ({ children }: { children: ReactNode }) => (
    <span style={{ whiteSpace: 'nowrap' }}>{children}</span>
  ),
  alignLeft: ({ children }: { children: ReactNode }) => (
    <span className="block text-left">{children}</span>
  ),
  alignCenter: ({ children }: { children: ReactNode }) => (
    <span className="block text-center">{children}</span>
  ),
  alignRight: ({ children }: { children: ReactNode }) => (
    <span className="block text-right">{children}</span>
  ),
})
